<template>
  <page title="轨迹查询">
    <div class="form">
      <div style="margin-top: 10px;">
        <mt-field placeholder="请输入单号" v-model="search.transNo" @keyup.enter.native="searchData()">
        </mt-field>
      </div>
      <div class="padded mt-gap2">
        <mt-button type="primary" style="width: 100%;" @click="searchData()">查询</mt-button>
      </div>
    </div>
    <div style="background: #fff;margin-top: 20px;" v-show="initSearch">
      <p class="search-title">查询条件</p>
      <div class="search-list">
        <span>单号：{{search.transNo}}</span>
      </div>
    </div>
    <div>
      <div class="mt-gap result" v-if="result.waybillNo">
        <div style="box-shadow: rgb(204, 204, 204) 0 1px 1px">
          <div style="padding: 10px;">
            <p>
              <span>参考编号</span> {{result.refNo}}
              <span class="fr" style="font-size: 14px;color: #19a0ff;" @click="detailShow = !detailShow">{{detailShow?'收起':'详情'}}</span>
            </p>
            <p><span>运单号码</span> {{result.waybillNo}}</p>
            <p><span>转单号码</span> {{result.transNo}}</p>
            <p><span>当前状态</span> {{result.status}}</p>
            <p><span>寄件日期</span> {{result.sendTime}}</p>
            <p v-if="disableFunc.indexOf('8_3') === -1"><span>收件邮编</span> {{result.receiverPostCode}}</p>
            <p v-if="disableFunc.indexOf('8_2') === -1"><span>收件备注</span> {{result.receiverRemark}}</p>
          </div>
        </div>
        <div class="child-info" v-show="detailShow">
          <div class="result-detail">
            <div class="step-item"
                 v-for="(item,index) in result.datas"
                 :key="index"
                 :class="{'cur': index === 0,
                      'step1': index===result.datas.length-1,
                      'step3': item.isFinish == 1,
                      'step2': item.isFinish != 1 && index !== result.datas.length-1 && index===1&&hasFinish,
                      'step2Cur': item.isFinish != 1 && index !== result.datas.length-1 && index===0}">
              <span class="icon"></span>
              <p><span style="margin-right: 10px;color:#26a2ff;">【{{item.status}}】</span></p>
              <p class="time">{{dateFormat(item.scanTime)}}</p>
              <p style="color: #333;font-size: 14px;">{{item.location}}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </page>
</template>
<script>
    import { Indicator } from 'mint-ui';
    export default {
        data() {
            return {
                search: {
                    transNo: '',
                    companyNo: '',
                    type: '2'
                },
                result: {datas: [{status: '已揽件', location: '各地政府开始了JFK浪费考六级大风看来大家几个人就立刻结果，司搭街坊昆仑山搭街坊卡拉，大家反抗类毒素解放，十六的客服就开始了对方角度看，角度上考虑肌肤抵抗力',scanTime: '2019-09-09 23:30:30'},{status: '已收货', location: '1212',scanTime: '2019-09-09 23:30:30'}]},
                initSearch: false,
                detailShow: false,
                disableFunc: [],
            }
        },
        created() {
            document.title="运单跟踪";
            this.search.companyNo = this.$util.get('companyNo');
            if (this.$route.query.waybillNo) {
                this.search.transNo = this.$route.query.waybillNo;
                this.searchData();
            }

        },
        computed: {
            hasFinish() {
                return this.result.datas&&this.result.datas[0].isFinish == 1;
            }
        },
        methods: {
            dateFormat(dateTime) {
                var date = new Date(dateTime);
                var year = date.getFullYear();
                var month = date.getMonth()+1;
                if (month < 10) {
                    month = '0'+month;
                }
                var day = date.getDate();
                if (day < 10) {
                    day = '0'+day;
                }
                var hours = date.getHours();
                if (hours < 10) {
                    hours = '0'+hours;
                }
                var minutes = date.getMinutes();
                if (minutes < 10) {
                    minutes = '0' + minutes
                }
                var seconds = date.getSeconds();
                if (seconds < 10) {
                    seconds = '0' + seconds;
                }
                return year+'-'+month+'-'+day + ' ' + hours+':'+minutes+':'+seconds;
            },
            searchData() {
                if (!this.search.transNo) {
                    this.$toast("请输入转单号码")
                } else {
                    this.initSearch = true;
                    this.$indicator.open({
                        spinnerType: 'fading-circle'
                    });
                    this.http.send({command: "realtimetracking/orderTracking", params: this.search}).then((res) => {
                        this.result = res.data.body;
                        this.$indicator.close();
                    }).catch(() => {
                        this.$indicator.close();
                    })
                }

            }
        }
    }
</script>
<style lang="less" scoped>
  .search-title{
    padding-top: 10px;
    text-align: center;
    color: #333;
    font-size: 16px;
  }
  .search-list{
    padding: 10px 10px 20px;
    span{
      font-size: 12px;
      color: #333;
      background: #f5f5f5;
      padding: 6px 8px;
      border-radius: 4px;
      margin-bottom: 4px;
      display: inline-block;
    }
  }
  .child-info {
    margin-top: 2px;
    padding: 0 10px;
    font-size: 14px;
  }
  .result {
    background-color: #fff;
    overflow: hidden;
    .btn {
      color: #19a0ff;
      border: 1px solid #19a0ff;
      border-radius: 4px;
      padding: 4px 6px;
      margin-top: 6px;
    }
    p {
      color: #666666;
      span {
        color: #333;
        margin-right: 8px;
      }
    }
  }
  .result-detail {
    background-color: #fff;
    padding: 20px 10px;
    margin-top: 10px;
    color: #666;
    font-size: 14px;
    .step-item {
      padding: 0 0 10px 30px;
      position: relative;
      &:after {
        content: "";
        width: 1px;
        height: 100%;
        position: absolute;
        top:0;
        bottom: 0;
        left: 10px;
        background: #ddd;
      }
      &.step1:after{
        height: 0;
      }
      .time {
        margin-top: 4px;
        color: #666;
        font-size: 13px;
        margin-bottom: 4px;
      }
      .icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        position: absolute;
        left: 0;
        z-index: 3;
      }
      &.step1 .icon {
        background-image: url("../assets/1.png");
        background-repeat: no-repeat;
        background-size: 20px auto;
        background-position: left top;
      }
      &.step2 .icon {
        background-image: url("../assets/2.png");
        background-repeat: no-repeat;
        background-size: 20px auto;
        background-position: left top;
      }
      &.step2Cur .icon{
        background-image: url("../assets/2h.png");
        background-repeat: no-repeat;
        background-size: 20px auto;
        background-position: left top;
      }
      &.step3 .icon {
        background-image: url("../assets/3.png");
        background-repeat: no-repeat;
        background-size: 20px auto;
        background-position: left top;
      }
      &.cur{
        color: #333;
        &.step1 .icon {
          background-image: url("../assets/1h.png");
        }
        &.step3 .icon {
          background-image: url("../assets/3h.png");
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/transfer.vue